if (!customElements.get('vtx-project-menu')) {
  class VtxProjectMenu extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.detail = this.closest('details');
      this.summary = this.detail?.querySelector('summary');
      this.mobile = this.detail?.hasAttribute('data-vtx-mobile-projects');
      this.viewport = matchMedia('(min-width:990px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.detail || !this.summary) return;
      this.summary.setAttribute('aria-expanded', String(this.detail.open));
      const canHover = event => !this.mobile && this.viewport.matches && event.pointerType !== 'touch';
      this.detail.addEventListener('pointerenter', event => {
        clearTimeout(this.leaveTimer);
        if (canHover(event)) this.open();
      }, {signal});
      this.detail.addEventListener('pointerleave', event => {
        if (!canHover(event)) return;
        this.leaveTimer = setTimeout(() => {
          if (!this.keyboard || !this.detail.contains(document.activeElement)) this.close();
        }, 200);
      }, {signal});
      this.detail.addEventListener('pointerdown', () => { this.keyboard = false; }, {signal});
      this.detail.addEventListener('keydown', event => {
        this.keyboard = true;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          this.summary.focus();
        } else if (event.target === this.summary && event.key === 'ArrowDown') {
          event.preventDefault();
          this.open();
          this.querySelector('a')?.focus();
        }
      }, {signal});
      this.detail.addEventListener('toggle', () => {
        this.summary.setAttribute('aria-expanded', String(this.detail.open));
        this.animation?.cancel();
        if (this.detail.open && !this.mobile && !this.reduced.matches && this.animate) {
          this.animation = this.animate([
            {opacity:.2, transform:'translateY(-8px)', clipPath:'inset(0 0 15% 0)'},
            {opacity:1, transform:'translateY(0)', clipPath:'inset(0 0 0 0)'}
          ], {duration:360, easing:'cubic-bezier(.16,1,.3,1)'});
        }
      }, {signal});
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.animation?.cancel();
      }, {signal});
      this.detail.addEventListener('focusout', () => {
        cancelAnimationFrame(this.focusFrame);
        this.focusFrame = requestAnimationFrame(() => {
          if (!this.detail.contains(document.activeElement) && !this.detail.matches(':hover')) this.close();
        });
      }, {signal});
      document.addEventListener('click', event => {
        if (!this.detail.contains(event.target)) this.close();
      }, {signal});
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          if (event.target !== this.detail || this.mobile) return;
          this.open();
        }, {signal});
      }
    }
    open() {
      clearTimeout(this.leaveTimer);
      this.detail.closest('[data-vtx-header-root]')?.querySelectorAll('.vtx-nav-disclosure').forEach(detail => {
        if (detail !== this.detail) detail.open = false;
      });
      this.detail.open = true;
      this.summary.setAttribute('aria-expanded', 'true');
    }
    close() {
      clearTimeout(this.leaveTimer);
      this.detail.open = false;
      this.summary.setAttribute('aria-expanded', 'false');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.leaveTimer);
      cancelAnimationFrame(this.focusFrame);
      this.animation?.cancel();
    }
  }
  customElements.define('vtx-project-menu', VtxProjectMenu);
}
if (!customElements.get('vtx-project-products')) {
  class VtxProjectProducts extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      const filters = this.querySelector('[data-vxp-filters]');
      const buttons = [...this.querySelectorAll('[data-vxp-filter]')];
      const cards = [...this.querySelectorAll('[data-vxp-connection]')];
      if (!filters || buttons.length < 2) return;
      filters.hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => {
        const value = button.dataset.vxpFilter;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = value !== 'all' && card.dataset.vxpConnection !== value; });
        const count = cards.filter(card => !card.hidden).length;
        const status = this.querySelector('[data-vxp-product-status]');
        if (status) status.textContent = `${this.dataset.countLabel} ${count}`;
      }, {signal}));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('vtx-project-products', VtxProjectProducts);
}
